import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-humidity-detail-template',
  templateUrl: './humidity-detail-template.component.html',
  styleUrls: ['./humidity-detail-template.component.less']
})
export class HumidityDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
